import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { ribbonDriverFactory } from './Ribbon.driver';
import { Ribbon, RibbonProps } from '.';

describe('Ribbon', () => {
  const createDriver = createRendererWithUniDriver(ribbonDriverFactory);

  const bootstrap = (props: Partial<RibbonProps> = {}) => {
    return createDriver(<Ribbon {...props} />);
  };

  it('should render', async () => {
    const { driver } = bootstrap();
    expect(await driver.exists()).toBe(true);
  });
});
